import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { BehaviorSubject, Observable } from "rxjs";

interface Producto {
    id: string;
    nombre: string;
    images: Array<object>;
    subtitle: string;
  }



@Injectable({
  providedIn: 'root',
})


export class FavoritosService {

    private claveCookieFavorites  = 'productosFavoritos';
    prodFavorites : BehaviorSubject<any[]> = new BehaviorSubject([]);

    constructor(
    @Inject(PLATFORM_ID) private platformID,
    ) {
      this.checkFavorites()
    }

    setProductFavorites(product: any){
      let list = this.obtenerFavoritos() || [];
      // Verificar si el producto ya está en la lista de favoritos
      if(Array.isArray(product) == false){
        if (!this.productoEstaEnFavoritos(product, list)) {
          list.push(product);
          
          this.actualizarFavoritos(list);
        }else{
          this.eliminarFavorito(product)
          list = this.obtenerFavoritos() || [];
        }
        this.prodFavorites.next(list)
      }else{

        this.actualizarFavoritos(list);
        this.prodFavorites.next(product)
      
      }
    
    }
    
  getProductFavorites(): Observable<any>{
    return this.prodFavorites
  }

  checkFavorites(){
      if(isPlatformBrowser(this.platformID)){
        let favorites = this.obtenerFavoritos()
        if(favorites && favorites.length > 0){
         this.setProductFavorites(favorites)
        }
      }
    }

  // Guardar producto como favorito
   guardarFavorito(producto: Producto): void {
    const favoritos = this.obtenerFavoritos() || [];

    // Verificar si el producto ya está en la lista de favoritos
    if (!this.productoEstaEnFavoritos(producto, favoritos)) {
      favoritos.push(producto);
      this.actualizarFavoritos(favoritos);
    }
  }

  // Obtener lista de productos favoritos
  obtenerFavoritos(): Producto[] {
    const favoritosCookie = this.getCookie(this.claveCookieFavorites);
    return favoritosCookie ? JSON.parse(favoritosCookie) : [];
  }

  // Eliminar producto de la lista de favoritos
  eliminarFavorito(producto: Producto): void {
    let favoritos = this.obtenerFavoritos() || [];

    // Filtrar la lista para eliminar el producto específico
    favoritos = favoritos.filter(p => p.id !== producto.id);

    this.actualizarFavoritos(favoritos);
  }

  // Función para establecer la cookie de favoritos
  private actualizarFavoritos(favoritos: Producto[]): void {
    localStorage.setItem(this.claveCookieFavorites, JSON.stringify(favoritos));
    // this.setCookie(this.claveCookieFavorites, JSON.stringify(favoritos));
  }

  // Función para establecer una cookie
  private setCookie(name: string, value: string): void {
    document.cookie = `${name}=${value}; path=/`;
  }

  // Función para obtener el valor de una cookie
  private getCookie(name: string): string | null {
    return localStorage.getItem(this.claveCookieFavorites)

    const cookies = document.cookie.split(';');
    for (const cookie of cookies) {
      const [cookieName, cookieValue] = cookie.trim().split('=');
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }

  // Función para verificar si un producto está en la lista de favoritos
  public productoEstaEnFavoritos(producto: Producto, favoritos: Producto[]): boolean {
    return favoritos.some(p => p.id == producto.id);
  }
}
